module.exports = __webpack_public_path__ + "static/media/CloseWhite.2f87d71c.svg";